 const COMMON_ACTION = {
     PAGE_SENDER : "PAGE_SENDER",
     TOAST: "TOAST"
 }
 export default COMMON_ACTION;